import React from 'react'

const ChooseUsChard = ({title,description,image_path}) => {
  return (
  <div className="card " style={{width: "18rem", height: "100%"}}>
    <div className='choose-us-image'>
      <img src={image_path} className="card-img-top" alt="..."/>
    </div>
      <div className="card-body choose-us-content">
        <h4>{title}</h4>
        <p className="card-text">{description}</p>
      </div>
  </div>
  )
}

export default ChooseUsChard